import { render, staticRenderFns } from "./DigerHacizForm.vue?vue&type=template&id=115fd840"
import script from "./DigerHacizForm.vue?vue&type=script&lang=ts"
export * from "./DigerHacizForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports